import React from "react";

export default function InfoPanel({
    title,
    children,
    className = "",
}) {
    return (
        <div
            className={`
                bg-white
                rounded-2xl
                shadow-md
                p-6
                ${className}
            `}
        >
            <h3 className="text-xl font-bold mb-5">

                {title}

            </h3>

            {children}
        </div>
    );
}